import Vue from 'vue'
import Vuex from 'vuex'

// Modules
// import axios from 'axios';
// import useJwt from '@/auth/jwt/useJwt';
import ElectronService from '@/services/ElectronService';
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import AuthModule from './modules/AuthModule';
import MyCallsModule from './modules/MyCallsModule';
import CallFeaturesModule from './modules/CallFeaturesModule';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isElectron: false,
  },
  mutations: {
    SET_IS_ELECTRON(state, value) {
      state.isElectron = value;
    },
  },
  actions: {
    backToTerminal() {
      ElectronService.backToTerminal();
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth: AuthModule,
    myCalls: MyCallsModule,
    callFeatures: CallFeaturesModule,
  },
  strict: process.env.DEV,
})
